import login from './login';
import invite from './invite';
import student_invite from './student_invite';
import org_invite_student from './org_invite_student';
import lowcode from './lowcode';
import privacy from './privacy';
import invite_perfect_info from './invite_perfect_info';

const store = {
  login,
  invite,
  student_invite,
  org_invite_student,
  lowcode,
  privacy,
  invite_perfect_info
};

export default store;
